<div class="main padding-1 space-between-horizontal-centered column-gap-0p25">
    <div class="row-gap-0p5 width-50pcnt start-row-container">
      <app-selector
        *ngIf="!buttons.confirm"
        data-qa="fs-model-selector"
        class="width-100pcnt"
        [data]="data"
        [selectedItem]="selectedItem"
        [selectedItemStyle]="modelSelectedItemStyle"
        [itemTextField]="'lastSaveText'"
        [textClass]="'main-8 bold600'"
        [field]="'name'"
        (itemEmitter)="modelChanged($event)">
      </app-selector>
      <app-input *ngIf="show.input && buttons.confirm" class="width-100pcnt"
        data-qa="fs-model-input-name"
        [input]="input"
        [autofocus]="true"
        [additionalClass]="isNameEmpty ? 'error' : ''"
        [placeholder]="'Type model name here'"
        (inputChange)="inputChangeEmitter($event)">
      </app-input>
    </div>
    <div class="end-row-container row-gap-0p375 width-50pcnt">
      <div *ngIf="!buttons.confirm && data?.length"
           class="centered-row-container row-gap-0p1">
        <div class="row-gap-0p375 flex">
          <app-button
            data-qa="fs-delete-model"
            [size]="'small'"
            [type]="'grey-white'"
            [iconName]="'delete.svg'"
            (buttonClick)="deleteModel()">
            Delete
          </app-button>
          <app-button
            data-qa="fs-duplicate-model"
            [size]="'small'"
            [type]="'grey-white'"
            [iconName]="'copy.svg'"
            (buttonClick)="buttonClicked.emit(editStatus.copyModel)">
            Duplicate
          </app-button>
          <app-button
            class="flex-none"
            data-qa="fs-export-excel-button"
            [size]="'small'"
            [type]="'grey-white'"
            [iconName]="'excel.svg'"
            (buttonClick)="exportExcelEmitter.emit()">
            Export
          </app-button>
          <app-button
            data-qa="fs-rename-model"
            [size]="'small'"
            [type]="'grey-white'"
            [iconName]="'edit.svg'"
            (buttonClick)="renameModel()">
            Rename
          </app-button>
      </div>
      <app-button
        class="flex00auto"
        data-qa="fs-add-model"
        [type]="'accent'"
        [size]="'small'"
        [iconName]="'plus.svg'"
        (click)="addNewModelClicked()">
        New model
      </app-button>
    </div>

    <div *ngIf="buttons.confirm" class="start-row-container row-gap-0p5">
      <app-button *ngIf="buttons.decline"
        data-qa="fs-cancel-button"
        [size]="'small'"
        (click)="declineClicked()">
        Cancel
      </app-button>
      <app-button  *ngIf="buttons.confirm && !buttons.rename"
        data-qa="fs-apply-button"
        [disabled]="!input"
        [size]="'small'"
        [type]="'accent'"
        (click)="confirmClicked()">
        Save
      </app-button>
      <app-button  *ngIf="buttons.rename"
        data-qa="fs-apply-button"
        [disabled]="!input"
        [size]="'small'"
        [type]="'accent'"
        (click)="confirmRename()">
        Rename
      </app-button>
    </div>
  </div>

  <app-modal-dialog  *ngIf="show.modalThinkTwice"
    [header]="'Delete model'"
    [useStandardList]="false"
    [mainText]="deleteModalTextList"
    [addAdditionalText]="true"
    (isConfirmed)="closeModalDeleteModel($event)">
</app-modal-dialog>
